// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__zXUZ-","label":"Category_label__eXntW","content":"Category_content__RNurg","header":"Category_header__3VVe_","location":"Category_location__1EC_l"};